import { render } from "./CollectionQualityChecksBase.vue?vue&type=template&id=7ef33678&scoped=true"
import script from "./CollectionQualityChecksBase.vue?vue&type=script&lang=js"
export * from "./CollectionQualityChecksBase.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ef33678"]])

export default __exports__